"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NORMALIZE_PHONE_NUMBER = void 0;
/**
 * Use this regular expression to normalize phone number input
 */
exports.NORMALIZE_PHONE_NUMBER = /[-\s.]/g;
//# sourceMappingURL=regexes.js.map